import { apiDownloadFile } from 'modules/actions';

export function downloadFile(hash, filename, params) {
  return apiDownloadFile(`/api/v1/assets/${hash}/${filename}${params}`, filename)
    .then(res => res)
    .catch((err) => {
      throw err;
    });
}
